// Parse the URL parameter
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Give the parameter a variable name
var action = getParameterByName('action');

$(document).ready(function () {
    if (action == 'subscribe') {
        $('body').addClass("subscribe-success");
    }
    if (action == 'signup') {
        $('body').addClass("signup-success");
    }
    if (action == 'signin') {
        $('body').addClass("signin-success");
    }
    $('.notification-close').click(function () {
        $(this).parent().addClass('closed');
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    });
});